import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  asset: generateApiPath({ prefix: AuthLevel.JWT_AUTH, name: 'asset' }),
}

export { paths }
